export default __webpack_public_path__ + "static/media/cover_large_06.515a9e97.jpg";